<template>
	<div>
		<h2>Address</h2>
		<hr>
		<el-form-item label="Street 1" :prop="prop + '.street_1'" :rules="rules.street_1">
			<el-input name="street_1" :value="street_1" @input="$emit('update:street_1', $event)"/>
		</el-form-item>
		<el-form-item label="Street 2" :prop="prop + '.street_2'" :rules="rules.street_2">
			<el-input name="street_2" :value="street_2" @input="$emit('update:street_2', $event)"/>
		</el-form-item>
		<el-row type="flex" :gutter="10">
			<el-col :sm="8">
				<el-form-item label="City" :prop="prop + '.city'" :rules="rules.city">
					<el-input name="city" :value="city" @input="$emit('update:city', $event)"/>
				</el-form-item>
			</el-col>
			<el-col :sm="8">
				<el-form-item label="State" :prop="prop + '.state'" :rules="rules.state">
					<el-input name="state" :value="state" @input="$emit('update:state', $event)"/>
				</el-form-item>
			</el-col>
			<el-col :sm="8">
				<el-form-item label="Zip Code" :prop="prop + '.zip'" :rules="rules.zip">
					<el-input name="zip" :value="zip" @input="$emit('update:zip', $event)"/>
				</el-form-item>
			</el-col>
		</el-row>
	</div>
</template>

<script>
export default{
	props: ['street_1', 'street_2', 'city', 'state', 'zip', 'prop'],
	data(){
		return{
			rules: {
				street_1: [
					{ required: true, message: 'Please input a street', trigger: 'blur' }
				],
				city: [
					{ required: true, message: 'Please input a city', trigger: 'blur' }
				],
				state: [
					{ required: true, message: 'Please input a state', trigger: 'blur' },
					{ min:2, max: 2, message: 'Please use the state abbreviation', trigger: 'blur'}
				],
				zip: [
					{ required: true, message: 'Please input a zip code', trigger: 'blur' },
					{ min:5, message: 'Please enter a valid zip code', trigger: 'blur'}
				],
			}
		}
	}
}
</script>

<style scoped>
h3{
	margin-top:50px;
}
</style>
